import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';


import store from './store';
import './i18n';
localStorage.setItem("theme", "Light");
localStorage.setItem("layout", "vertical");
const app = (
    <Provider store={store}>
        <BrowserRouter>
        <Suspense fallback={(<div></div>)}>
            <App />
        </Suspense>
        </BrowserRouter>
    </Provider>
);

ReactDOM.render(app, document.getElementById('root'));
serviceWorker.unregister();
